var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "branch-table"
  }, [_c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-0",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.branchTable",
      modifiers: {
        "branchTable": true
      }
    }],
    attrs: {
      "block": "",
      "variant": "secondary"
    }
  }, [_vm._v("共：" + _vm._s(_vm.computedBranches.length) + " 筆")])], 1), _c('b-collapse', {
    attrs: {
      "id": "branchTable",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', [_c('div', {
    staticClass: "branches-table d-flex flex-wrap"
  }, _vm._l(_vm.computedBranches, function (branch) {
    return _c('div', {
      key: branch,
      staticClass: "branches-item"
    }, [_vm._v(" " + _vm._s(branch) + " ")]);
  }), 0)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }